import { render } from "./PageFooter.vue?vue&type=template&id=ef2705dc&scoped=true"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"

import "./PageFooter.vue?vue&type=style&index=0&id=ef2705dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef2705dc"]])

export default __exports__